'use strict'

import Vue from 'vue'

import store from 'src/vuex/store.js'

class ConfigStoreClass {

  constructor () {
    this.initStore()

    this.setListeners()
  }

  static getConfigModelPromise () {
    return Promise.reject(new Error('not set yet'))
  }

  static getRegisterModuleName () {
    return 'Config'
  }

  getConfigsMap () {
    if (!this.configs) this.configs = {}

    return this.configs
  }

  getConfigsProxy () {
    if (this.configsProxy) return this.configsProxy

    const getConfigModel = this.constructor.getConfigModelPromise()

    this.configsProxy = new Proxy(this.getConfigsMap(), {
      get (target, name) {
        const val = target[name]

        if (val === undefined
          && !(name in target)
          && name
          && typeof name === 'string'
          && name.charAt(0) !== '_'
          && ['render', 'toJSON', 'state'].indexOf(name) === -1
        ) {
          getConfigModel
            .then(Config => Config.getConfig(name)
              // .then(val => {
              //   target[name] = val
              // })
            )
        }

        return val
      }
    })

    return this.configsProxy
  }

  initStore () {
    this.store = store

    const getConfigModel = this.constructor.getConfigModelPromise()

    const state     = {
      configs : this.getConfigsProxy(),
    }
    const getters   = {
      getConfig : (state) => (name, defVal = undefined) => {
        let val = state.configs[name]
        if (val === undefined) {
          Vue.set(state.configs, name, defVal)

          getConfigModel
            .then(Config => Config.getConfig(name)
              .then(val => {
                state.configs[name] = val
              }))

          return defVal
        }
        return val
      }
    }
    const mutations = {
      setConfig (state, data) {
        if (data.name && data.val !== undefined) {
          Vue.set(state.configs, data.name, data.val)
          // state.configs[data.name] = data.val
        }
      }
    }
    const actions   = {
      setConfig (context, data) {
        if (data.name && data.val !== undefined) {
          console.log(context)
          let oldVal = context.state.configs[data.name]

          context.commit('setConfig', data)

          getConfigModel
            .then(Config => Config._saveConfigVal(data.name, data.val))
            .then(resp => {
              if (resp.error) {
                // todo noty error

                context.commit('setConfig', {
                  name : data.name,
                  val : oldVal,
                })
              }
            })
        }
      }
    }

    this.registerModule({
      namespaced: true,
      state,
      getters,
      mutations,
      actions,
    })
  }

  registerModule (opts) {
    store.registerModule(this.constructor.getRegisterModuleName(), opts)
  }

  setListeners () {

  }

}

export default ConfigStoreClass
